

import { Component, Vue } from "vue-property-decorator";
import { ParticaEvent, eParticaAction } from "../../Models/ParticaEvent";
@Component({
	name: "ParticaUIBase"
})
export default class ParticaUIBase extends Vue {

	protected raiseEvent(event: string, action: eParticaAction, item: any) {
		const pevent: ParticaEvent = { action, item } as ParticaEvent;
		this.$emit(event, pevent);
	}
}
